import { Routes } from '@angular/router';
import { AppRoutesEnum } from './enums/app-routes.enum';
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  {
    path: AppRoutesEnum.callback,
    loadComponent: () => import('./pages/callback/callback').then((c) => c.Callback),
  },
  {
    path: AppRoutesEnum.anlagePlanung,
    loadComponent: () =>
      import('./pages/anlageplannung/anlageplannung').then((c) => c.Anlageplannung),
    canActivate: [authGuard],
  },
  {
    path: AppRoutesEnum.belvoto,
    loadComponent: () => import('./pages/belvoto/belvoto').then((c) => c.Belvoto),
    canActivate: [authGuard],
  },
  {
    path: AppRoutesEnum.ninHistory,
    loadComponent: () => import('./pages/nin-history/nin-history').then((c) => c.NinHistory),
    canActivate: [authGuard],
  },
  {
    path: AppRoutesEnum.cockpit,
    loadComponent: () => import('./pages/cockpit/cockpit').then((c) => c.Cockpit),
    canActivate: [authGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found').then((c) => c.PageNotFound),
  },
];
